import { ReactNode, createContext, useContext } from "react";

interface HeaderContextProps {
  isLegacy: boolean;
}

const HeaderContext = createContext<HeaderContextProps | undefined>(undefined);

interface HeaderContextProviderProps {
  isLegacy?: boolean;
  children: ReactNode;
}

export const HeaderContextProvider = ({
  isLegacy = false,
  children,
}: HeaderContextProviderProps) => {
  return (
    <HeaderContext.Provider value={{ isLegacy }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => {
  const headerContext = useContext(HeaderContext);

  if (!headerContext) {
    return { isLegacy: false };
  }

  return headerContext;
};
